(function () {
	'use strict';

	angular.module('mx.shell').component('mxHorizontalActionList', {
		bindings: {
			actions: '<',
			context: '<?',
			view: '<',
			actionListAriaLabel: '@',
		},
		controller: MxHorizontalActionListCtrl,
		controllerAs: 'vm',
		templateUrl: 'components/mx-horizontal-action-list/mx-horizontal-action-list.html',
	});

	MxHorizontalActionListCtrl.$inject = [
		'mx.internationalization',
		'mx.app.DeviceService',
		'mx.shell.ActionExecutorService',
		'mx.shell.KeyboardNavigationService',
		'$scope',
		'mx.shell.View',
		'mx.shell.EventService',
		'$timeout',
		'$element',
		'$mdConstant',
	];

	function MxHorizontalActionListCtrl(i18n, deviceService, actionExecutorService, keyboardNavigationService, $scope, MxView, eventService, $timeout, $element, $mdConstant) {
		var vm = this;
		var _amountToCut = deviceService.screenDesktop() ? 20 : 10; // Max action amount on the panel
		var containerEl;
		vm.moreListAriaLink = mx.components.Utils.genElemId('mx-horizontal-action-list--more-');
		vm._majorActions = [];
		vm.showMorePanel = false;

		//  todo - rework hot-keys to be able use them again
		vm.$postLink = function () {
			initKeyboardControl();
		};

		vm.$onChanges = function (changes) {
			if (changes.actions) {
				// set visibility:visible for all current actions before filtering to avoid flickering after next filtering
				// when some actions will be rendered again
				showAllActions();

				if (Array.isArray(changes.actions.currentValue)) {
					vm._majorActions = changes.actions.currentValue.slice(0, _amountToCut);
					_debouncedCheckMoreBtnVisibility();
					if (!registerHotkeys.__inited) {
						registerHotkeys.__inited = true;
						window.setTimeout(function () {
							registerHotkeys($scope, i18n, keyboardNavigationService);
						}, 1000);
					}
				} else {
					vm._majorActions = [];
				}

				$timeout(function () {
					checkButtonsVisibility();
				});
			}
		};

		var _debouncedCheckMoreBtnVisibility = $.debounce(100, function () {
			$scope.$evalAsync(checkButtonsVisibility);
		});

		vm.handleActionClick = function (action) {
			vm.showMorePanel = false;

			actionExecutorService.execute(action, vm.context ? (Array.isArray(vm.context) && vm.context) || [vm.context] : undefined, vm.view).catch(mx.logCatch);
		};

		eventService.subscribeTo(mx.shell.EventCodes.LayoutChanged, _debouncedCheckMoreBtnVisibility, $scope);

		function getActionsContainer() {
			containerEl = containerEl || $element.find('.mx-horizontal-action-list-container');
			return containerEl;
		}

		function getActionButtons() {
			var container = getActionsContainer();
			if (container && container.is(':visible')) {
				return $(container).find('.mx-horizontal-action-list--action');
			}
		}

		function showAllActions() {
			var allButtons = getActionButtons();
			if (allButtons) {
				allButtons.show();
			}
		}

		function checkButtonsVisibility() {
			var container = getActionsContainer();

			if (!container) {
				return;
			}
			if (container.is(':visible')) {
				var allButtons = getActionButtons();
				var firstBtnOffset,
					moreThan1Line = false;
				allButtons.show();
				allButtons.each(function (i, btn) {
					if (i === 0) {
						firstBtnOffset = btn.offsetTop;
					} else if (moreThan1Line || btn.offsetTop > firstBtnOffset) {
						moreThan1Line = true;
						$(btn).hide();
					}
				});
				vm.showMoreButton = moreThan1Line;
				if (vm.showMoreButton) {
					vm.morePanelTopOffset = container.position().top + 35;
				}
			} else {
				vm.showMorePanel = false;
			}
		}

		function initKeyboardControl() {
			$element.keydown(function (e) {
				var focusedEl;

				if (vm.showMorePanel) {
					if (e.keyCode === $mdConstant.KEY_CODE.DOWN_ARROW || e.keyCode === $mdConstant.KEY_CODE.UP_ARROW) {
						e.preventDefault();
						focusedEl = $element.find('.mx-horizontal-action-list--more-action:focus');
						if (e.keyCode === $mdConstant.KEY_CODE.DOWN_ARROW) {
							if (focusedEl.length) {
								focusedEl.next().focus();
							} else {
								$($element.find('.mx-horizontal-action-list--more-action')[0]).focus();
							}
						} else if (e.keyCode === $mdConstant.KEY_CODE.UP_ARROW && focusedEl.length) {
							focusedEl.prev().focus();
						}
					}

					if (e.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
						e.preventDefault();
						$timeout(function () {
							vm.showMorePanel = false;
						});
					}
				}
			});
		}

		function registerHotkeys(scope, i18n, keyboardNavigationService) {
			keyboardNavigationService.registerKey([
				{
					// Scope: scope,
					key: 'alt+s',
					description: i18n.get('shell.mx-side-panel-actions.save'),
					onRegister: function () {
						window.setTimeout(function () {
							$element.find('.mx-side-panel-details-view-actions .mx-horizontal-action-list--action[mx-at-id*="save"]').attr('hint-key', 's');
						});
					},
					callback: function () {
						$timeout(function () {
							$('.mx-side-panel-details-view-actions .mx-horizontal-action-list--action[mx-at-id*="save"]:not([disabled]):visible').click();
						});
					},
				},
				{
					// Scope: scope,
					key: 'alt+e',
					description: i18n.get('shell.mx-side-panel-actions.edit'),
					onRegister: function () {
						window.setTimeout(function () {
							$('.mx-side-panel-details-view-actions .mx-horizontal-action-list--action[mx-at-id*="edit"]').attr('hint-key', 'e');
							$('.mx-side-panel-selection-actions .mx-horizontal-action-list--action[mx-at-id*="edit"]').attr('hint-key', 'e');
						}, 800);
					},
					callback: function () {
						$timeout(function () {
							$('.mx-side-panel-details-view-actions .mx-horizontal-action-list--action[mx-at-id*="edit"]:not([disabled]):visible').click();
							$('.mx-side-panel-selection-actions .mx-horizontal-action-list--action[mx-at-id*="edit"]:not([disabled]):visible').click();
						});
					},
				},
				{
					// Scope: scope,
					key: 'alt+x',
					description: i18n.get('shell.mx-side-panel-actions.delete'),
					onRegister: function () {
						window.setTimeout(function () {
							$('.mx-side-panel-details-view-actions .mx-horizontal-action-list--action[mx-at-id*="cancel"]:not([Deleteobjects]):visible').attr('hint-key', 'x');
							$('.mx-side-panel-selection-actions .mx-horizontal-action-list--action[mx-at-id*="cancel"]:not([Deleteobjects]):visible').attr('hint-key', 'x');
						}, 800);
					},
					callback: function () {
						$timeout(function () {
							$('.mx-side-panel-details-view-actions .mx-horizontal-action-list--action[mx-at-id*="Deleteobjects"]:not([disabled]):visible').click();
							$('.mx-side-panel-selection-actions .mx-horizontal-action-list--action[mx-at-id*="Deleteobjects"]:not([disabled]):visible').click();
						});
					},
				},
				{
					// Scope: scope,
					key: 'alt+c',
					description: i18n.get('shell.mx-side-panel-actions.cancel'),
					onRegister: function () {
						window.setTimeout(function () {
							$('.mx-side-panel-details-view-actions .mx-horizontal-action-list--action[mx-at-id*="cancel"]').attr('hint-key', 'c');
							$('.mx-side-panel-selection-actions .mx-horizontal-action-list--action[mx-at-id*="cancel"]').attr('hint-key', 'c');
						}, 800);
					},
					callback: function () {
						$timeout(function () {
							$('.mx-side-panel-details-view-actions .mx-horizontal-action-list--action[mx-at-id*="cancel"]:not([disabled]):visible').click();
							$('.mx-side-panel-selection-actions .mx-horizontal-action-list--action[mx-at-id*="cancel"]:not([disabled]):visible').click();
						});
					},
				},
				{
					// Scope: scope,
					key: 'alt+d',
					description: i18n.get('shell.mx-side-panel-actions.done'),
					onRegister: function () {
						window.setTimeout(function () {
							$('.mx-side-panel-details-view-actions .mx-horizontal-action-list--action[mx-at-id*="done"]').attr('hint-key', 'd');
							$('.mx-side-panel-selection-actions .mx-horizontal-action-list--action[mx-at-id*="done"]').attr('hint-key', 'd');
						}, 800);
					},
					callback: function () {
						$timeout(function () {
							$('.mx-side-panel-details-view-actions .mx-horizontal-action-list--action[mx-at-id*="done"]:not([disabled]):visible').click();
							$('.mx-side-panel-selection-actions .mx-horizontal-action-list--action[mx-at-id*="done"]:not([disabled]):visible').click();
						});
					},
				},
			]);
		}
	}
})();
